<template>
  <v-row justify="center">
    <v-dialog
      v-model="getPreordiniCreate"
      persistent
      max-width="600px"
    >
      <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="true"
        autocomplete="off"
      >
        <v-card>
          <v-card-title>
            <span class="headline primary--text font-weight-bold">Nuovo Preordine</span>
          </v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-autocomplete
                  v-model="preorder.customer_id"
                  :items="customers"
                  :search-input.sync="searchCustomer"
                  hide-no-data
                  hide-selected
                  item-text="fullname"
                  item-value="id"
                  label="Cliente"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-row>

              <v-row>
                <v-autocomplete
                  v-model="preorder.id"
                  :items="articles"
                  :search-input.sync="searchDevice"
                  hide-no-data
                  hide-selected
                  item-text="text"
                  item-value="id"
                  label="Articolo"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-row>

              <v-row>
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Nuovo Articolo
                    </v-expansion-panel-header>
                    <v-expansion-panel-content v-if="kind == 'devices'">
                      <v-text-field
                        label="Brand"
                        v-model="device.brand"
                      ></v-text-field>
                      <v-text-field
                        label="Modello"
                        v-model="device.model"
                      ></v-text-field>
                      <v-text-field
                        label="HDD"
                        v-model="device.disk_space"
                      ></v-text-field>
                      <v-text-field
                        label="RAM"
                        v-model="device.ram"
                      ></v-text-field>
                      <v-text-field
                        label="Colore"
                        v-model="device.color"
                      ></v-text-field>
                    </v-expansion-panel-content>

                    <v-expansion-panel-content v-if="kind == 'accessori'">
                      <v-text-field
                        label="Marchio"
                        v-model="accessory.brand"
                      ></v-text-field>
                      <v-text-field
                        label="Prodotto"
                        v-model="accessory.model"
                      ></v-text-field>
                      <v-text-field
                        label="Colore"
                        v-model="accessory.color"
                      ></v-text-field>
                      <v-text-field
                        label="Modello"
                        v-model="accessory.desctiption"
                      ></v-text-field>
                    </v-expansion-panel-content>

                    <v-expansion-panel-content v-if="kind == 'ricambi'">
                      <v-text-field
                        label="Nome"
                        v-model="replacement.name"
                      ></v-text-field>
                      <v-text-field
                        label="Modello"
                        v-model="replacement.model"
                      ></v-text-field>
                      <v-select
                        v-model="replacement.state"
                        :items="[{text: 'ORIGINALE', value: 'ORIGINALE'}, {text: 'COMPATIBILE', value: 'COMPATIBILE'}]"
                        item-text="text"
                        item-value="value"
                        label="Stato"
                      ></v-select>
                      <v-text-field
                        label="Colore"
                        v-model="replacement.color"
                      ></v-text-field>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-row>

              <v-row>
                <v-textarea
                  label="Note"
                  v-model="preorder.description"
                ></v-textarea>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="create"
            >Salva</v-btn>
            <v-btn
              color="primary"
              @click="dismiss"
            >Annulla</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    name: 'CreateDialog',

    props: {
      kind: {
        type: String,
        default: null
      }
    },

    data() {
      return {
        menu: false,
        valid: false,
        customers: [],
        articles: [],
        searchCustomer: null,
        searchDevice: null,
        preorder: {
          customer_id: null,
          id: null,
          description: null
        },
        device: {
          brand: null,
          model: null,
          disk_space: null,
          ram: null,
          color: null
        },
        accessory: {
          brand: null,
          model: null,
          color: null,
          desctiption: null
        },
        replacement: {
          name: null,
          model: null,
          state: null,
          color: null,
          cost: 0.00,
          price: 0.00,
          amount: '0',
          supplier_id: 1
        },
        rules: {
          required: (value) => !!value || 'Campo obbligatorio.',
        },
        config: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        },
      }
    },

    computed: {
      ...mapGetters([
        'getPreordiniCreate'
      ])
    },

    methods: {
      async fetchCustomers() {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API}/v2/customers/fetch`,
          this.config
        )

        let customers = data.map(customer => {
          customer.fullname = `${customer.name} ${customer.surename}`
          return customer
        })

        this.customers = customers
      },

      async _fetch() {
        let articles

        switch (this.kind) {
          case 'devices':
            let { data: devices } = await axios.get(
              `${process.env.VUE_APP_API}/v2/smartphones/blueprint/fetch`,
              this.config
            )

            articles = devices.map((device, index) => {
              devices[index].text = `${device.brand} ${device.model} ${device.color} ${device.disk_space} ${device.ram}`
              return device
            })

            break
          case 'accessori':
            let { data: accessories } = await axios.get(
              `${process.env.VUE_APP_API}/accessories/fetch`,
              this.config
            )

            articles = accessories.map((accessory, index) => {
              accessories[index].text = `${accessory.brand} ${accessory.model} ${accessory.color} ${accessory.desctiption}`
              return accessory
            })

            break
          case 'ricambi':
            let { data: replacements } = await axios.get(
              `${process.env.VUE_APP_API}/replacements/fetch`,
              this.config
            )

            articles = replacements.map((replacement, index) => {
              replacements[index].text = `${replacement.name} ${replacement.model} ${replacement.color} ${replacement.state}`
              return replacement
            })

            break
        }

        this.articles = articles
      },

      dismiss() {
        this.$emit('dismiss')
      },

      async create() {
        if (this.$refs.form.validate()) {
          const { data } = await axios.post(
            `${process.env.VUE_APP_API}/preorders/insert/${this.kind}`,
            this.preorder,
            this.config
          )

          if (data.status) {
            this.$emit('saved')
          }
        }
      },
    },

    watch: {
      kind: {
        handler() {
          this._fetch()
        },
        immediate: true,
        deep: true
      }
    },

    async mounted() {
      await this.fetchCustomers()
    }
  }
</script>